// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__u6LHb","header":"styles_header__pvwDf","action":"styles_action__nhD5K","resume":"styles_resume__IZUkL","startOver":"styles_startOver__KCbgx"};